import { sarApi } from '@/apis';

export default {
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {String} id
   */
  async initSarDetail({ commit, dispatch }, id) {
    commit('reset');
    commit('setLoading', true);
    const requests = [dispatch('fetchDetail', id)];
    await Promise.all(requests);
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} id
   */
  async fetchDetail({ commit, rootGetters }, id) {
    const token = rootGetters['auth/token'];
    try {
      const response = await sarApi.requestDetail(token, id);
      commit('setDetail', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
};
